import React, { Fragment } from "react";
import d from "dayjs";
import "dayjs/locale/sv";
import PropTypes from "prop-types";
import { Flex, Box, Image } from "rebass";
import { css } from "styled-components";
import { ImageRatio } from "../../components/Image";
import { ColorOverlay } from "../../components/ui/ColorOverlay";
import { RichText } from "../../components/RichText";
import { Bold, Paragraph, Heading } from "../../components/Text";
import SEO from "../../components/seo";

d.locale("sv");

const Artist = ({ pageContext }) => {
  const {
    description,
    seo,
    image: {
      fluid: { src, srcSet, sizes },
    },
  } = pageContext;

  return (
    <Fragment>
      <SEO
        title={pageContext.name}
        description={seo.description?.description}
        keywords={seo.keywords || []}
        image={seo.image?.resize?.src}
      />
      <Box
        width={[1, 1]}
        mx={[0, 0, "auto"]}
        color="white"
        pb={[6, 6, 5]}
        css={css`
          max-width: 860px;
          z-index: 1;
          position: relative;
        `}
      >
        <Flex
          width={[1]}
          flexDirection={["column"]}
          alignItems={[
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "flex-end",
          ]}
          mb={[6, 7]}
        >
          <Heading as="h1">{pageContext.name}</Heading>
          <Box
            width={["auto", "auto", "auto", "auto", "auto", 4 / 5]}
            mt={[0, 0, 0, 0, 4]}
            mb={[4, 5]}
            mx={[-3, -3, -4, -4, 0]}
          >
            <ImageRatio>
              <Image
                width={1}
                src={src}
                srcSet={srcSet}
                sizes={sizes}
                alt={pageContext.name}
              />
            </ImageRatio>
          </Box>
          <Box ml={4} width={["auto", "auto", "auto", "auto", "auto", 4 / 5]}>
            <RichText
              BOLD={(text) => <Bold>{text}</Bold>}
              PARAGRAPH={(_, children) => (
                <Paragraph mb={3}>{children}</Paragraph>
              )}
              A={(node, children) => (
                <Bold
                  as="a"
                  href={node.data.uri}
                  css={css`
                    color: inherit;
                    display: block;
                    text-decoration: underline;
                    text-transform: uppercase;
                  `}
                >
                  {children}
                </Bold>
              )}
              HEADING={(children, { level }) => (
                <Heading as={`h${level}`}>{children}</Heading>
              )}
              document={description.raw}
            />
            {pageContext.event && pageContext.event?.[0] ? (
              <Box color="green">
                <p>
                  Spelar på {pageContext.event?.[0].eventVenue?.title},{" "}
                  {d(pageContext.event?.[0].start).format("dddd kl HH:mm")}
                </p>
              </Box>
            ) : null}
          </Box>
        </Flex>
      </Box>
      <ColorOverlay
        colors={[
          "rgba(0, 0, 0, 0.9)",
          "rgba(0, 0, 0, 0.9)",
          "rgba(0, 0, 0, 0.9)",
        ]}
      />
    </Fragment>
  );
};

Artist.propTypes = {
  pageContext: PropTypes.object.isRequired,
};

export default Artist;
